import { createAction } from 'typesafe-actions';
import { LoadingApi } from './model';
import * as types from './types';

export const clearData = createAction(types.CLEAR_DATA)();
export const addLoadingApi = createAction(types.ADD_LOADING_API)<LoadingApi>();
export const removeLoadingApi = createAction(types.REMOVE_LOADING_API)<LoadingApi>();
